import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import * as stripeService from '../../services/stripeService';
import globalActionConstants from '../constants/globalActionConstants';
import stripeActionConstants from '../constants/stripeActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const createPaymentMethod = () => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });

  const response = await stripeService.createPaymentMethod();
  dispatch({ type: globalActionConstants.SET_LOADING_OFF });

  if (response.data.response_code === responseCodes.OK) {
    return response.data.payload;
  }
  Notification.error(response.data.error);
};

export const createBillingSession = () => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });

  const response = await stripeService.createBillingSession();
  if (response.data.response_code === responseCodes.OK) {
    window.location.href = response.data.payload;
  } else {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(response.data.error);
  }
};

export const createDashboardSession = () => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });

  const response = await stripeService.createDashboardSession();
  dispatch({ type: globalActionConstants.SET_LOADING_OFF });
  if (response.data.response_code === responseCodes.OK) {
    setTimeout(() => {
      window.open(response.data.payload, '_blank');
    }, 100);
  } else {
    Notification.error(response.data.error);
  }
};

export const getCustomer = (id) => async (dispatch) => {
  dispatch({ type: stripeActionConstants.GET_CUSTOMER });

  const response = await stripeService.getCustomer(id);
  if (response.data.response_code === responseCodes.OK) {
    return dispatch({
      type: stripeActionConstants.GET_CUSTOMER_SUCCESS,
      payload: response.data.payload,
    });
  }
  dispatch({ type: stripeActionConstants.GET_CUSTOMER_ERROR });
  Notification.error(response.data.error);
};

export const updateCustomerPaymentMethod = (id, accountMethod, rewardMethod) => async (dispatch) => {
  dispatch({ type: stripeActionConstants.UPDATE_CUSTOMER_PAYMENT_METHOD });

  const response = await stripeService.updateCustomerPaymentMethod(id, accountMethod, rewardMethod);
  if (response.data.response_code === responseCodes.OK) {
    return dispatch({
      type: stripeActionConstants.UPDATE_CUSTOMER_PAYMENT_METHOD_SUCCESS,
      payload: response.data.payload,
    });
  }
  dispatch({ type: stripeActionConstants.UPDATE_CUSTOMER_PAYMENT_METHOD_ERROR });
  Notification.error(response.data.error);
};

export const createStripeUser = (navigateCallback) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });

  const response = await stripeService.createStripeUser();

  if (response.data.response_code === responseCodes.OK) {
    window.location.href = response.data.payload;
  } else {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (navigateCallback) {
      Notification.error(t('payments.countryNotSupported'));
      navigateCallback();
    } else {
      Notification.error(response.data.error);
    }
  }
};
